import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router";
import Footer from "../components/shared/Footer";
import { Box } from "../components/utils";
import useIsMobile from "../utils/detectDevice";
import MainSideNavbar from "./MainSideNavbar";
import SwitchProduct from "./SwitchProduct";
import MobileSideNav from "./MobileSideNav";
import { useAuthStore } from "../store";
import { TopBarWrapper } from "./TopBar/TopBarWrapper";
import { useCheckHeartBeat } from "../queries/auth";
import { isEquionSessionInvalid, redirectToIdentitySignIn } from "../api/auth";
import DraftCompanyInfo from "../pages/dashboardPage/DraftCompanyInfo";
import VaultDownloadEventListener from "../components/companyDocuments/VaultDownloadEventListener";

function MainLayout() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const {
    error,
    isError,
    refetch: retryHeartbeat,
  } = useCheckHeartBeat(window.self === window.top);

  const handleDialogOpen = (value: boolean) => {
    setDialogOpen(!dialogOpen);
  };
  const location = useLocation();
  const { isMobile } = useIsMobile(1024);
  useEffect(() => {
    const scroller = document.querySelector("#outlet");
    scroller?.scrollTo(0, 0);
  }, [location]);

  const user = useAuthStore((s) => s.user);
  const isDraftCompany = Boolean(user?.isDraftCompany);
  // Draft companies can still open onboarding routes. This includes the external
  // cap-table flow, which is how a draft company receives its first cap table.
  const isDraftAllowedRoute =
    /companydetail|companyprofile|setting\/users|onboarding\/company|external-captable/i.test(
      location.pathname
    );
  const showDraftInfo = isDraftCompany && !isDraftAllowedRoute;

  const companyStage = user?.stage ?? "Four";
  const [stage, setStage] = useState(companyStage);

  useEffect(() => {
    if (!user) return;
    if (stage !== undefined && companyStage !== stage) {
      setStage(companyStage);
      window.location.reload();
    }
  }, [companyStage, stage, user]);

  useEffect(() => {
    if (isError && isEquionSessionInvalid(error)) {
      redirectToIdentitySignIn();
    }
  }, [error, isError]);

  if (isError) {
    if (isEquionSessionInvalid(error)) return null;
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
        <p>Session check is unavailable.</p>
        <button type="button" onClick={() => retryHeartbeat()}>
          Retry
        </button>
      </div>
    );
  }

  return (
    <>
      <VaultDownloadEventListener />
      {isMobile ? (
        <div className="flex">
          {/* <div className="relative w-20 h-screen overflow-hidden md:flex">
           */}
          {/* </div> */}
          {dialogOpen && (
            <div className="absolute bg-black w-96">
              <SwitchProduct setDialogOpen={handleDialogOpen} />
            </div>
          )}
          <div className="flex-1 h-screen overflow-y-auto" id="outlet">
            <div className="relative w-full min-h-screen">
              <div className={`sticky top-0 z-20`}>
                <MobileSideNav />
              </div>
              <Box className="max-w-screen-xl py-2 px-4 pb-32 mx-auto">
                {showDraftInfo ? (
                  <DraftCompanyInfo companyName={user?.nameOfTheCompany} />
                ) : (
                  <Outlet />
                )}
              </Box>
              <div></div>
              <div className="absolute bottom-0 w-full mt-6 ">
                <Footer />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex">
          <div className="fixed top-0 left-0 z-[60] w-full bg-white">
            <TopBarWrapper />
          </div>
          {!isDraftCompany && (
            <div className="relative w-20 h-screen overflow-hidden md:flex pt-16">
              {stage && <MainSideNavbar setDialogOpen={handleDialogOpen} />}
            </div>
          )}
          {dialogOpen && (
            <div className="absolute bg-black w-96 z-20">
              <SwitchProduct setDialogOpen={handleDialogOpen} />
            </div>
          )}
          <div className="flex-1 h-screen overflow-y-auto pt-14" id="outlet">
            <div className="relative w-full min-h-screen">
              <Box className="py-4 px-8 pb-32 mx-auto">
                {showDraftInfo ? (
                  <DraftCompanyInfo companyName={user?.nameOfTheCompany} />
                ) : (
                  <Outlet />
                )}
              </Box>
              <div></div>
              <div className="absolute bottom-0 w-full mt-6 ">
                <Footer />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default MainLayout;
